import { render, staticRenderFns } from "./PlanUpgradeCard.vue?vue&type=template&id=183ab353&scoped=true&"
import script from "./PlanUpgradeCard.vue?vue&type=script&lang=js&"
export * from "./PlanUpgradeCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=183ab353&prod&lang=less&scoped=true&"
import style1 from "./PlanUpgradeCard.vue?vue&type=style&index=1&id=183ab353&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ab353",
  null
  
)

export default component.exports